import React from 'react';

const isFalse = (v) => v === false;

const allTrue = (mandatory, props) =>
  mandatory.map((k) => props[k]).findIndex(isFalse) === -1;

export default (mandatory) => (Component) => (props) =>
  allTrue(mandatory, props) ? <Component {...props} /> : null;
